import { render, staticRenderFns } from "./responsibleGaming.vue?vue&type=template&id=7c3cf374"
import script from "./responsibleGaming.vue?vue&type=script&lang=js"
export * from "./responsibleGaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports